import { combineReducers } from 'redux';


import { sharedReducer } from './sharedReducer';
import { symbolReducer } from './symbolReducer';
import { indexReducer } from './indexReducer';
import { userReducer } from './userReducer';
import { boardMarketReducer } from './boardMarketReducer';

const reducers = combineReducers({
    gShared: sharedReducer,
    gSymbol: symbolReducer,
    gIndex: indexReducer,
    gUser: userReducer,
    gBoard: boardMarketReducer,
});

export default reducers;